import { useEffect } from "react"
import throttle from "lodash/throttle"

export function useIsOutOfView(component, callBack) {
  const getElemXPosition = (elem) => {
    return elem.x + elem.width
  }

  const getScreenWidth = () => {
    return document.body.clientWidth || window.innerWidth
  }

  const isElementOffView = () => {
    const current = component.current

    if (current) {
      const elem = current.getBoundingClientRect()
      let elemXPos = getElemXPosition(elem)
      let screenSize = getScreenWidth() - 30 //minus 30 for the scrollbar OS issues on resize

      return elemXPos > screenSize
    }
  }

  useEffect(() => {
    callBack(isElementOffView())

    const resizeHandle = () => {
      callBack(isElementOffView())
    }

    window.addEventListener(
      "resize",
      throttle(resizeHandle, 500, { trailing: true })
    )
    return () => {
      removeEventListener("resize", resizeHandle)
    }
  }, [])
}
